import { LineItem } from "../../types/ecomm.types";

export const getFallbackChildData = (line_items: LineItem[] | undefined) => {
  return line_items?.[0]?.meta_data?.reduce(
    (acc: { childMedia?: { cgpUrl: string }[]; givenName?: string }, { key, value }) => {
      if (key === "wvus_product_image") {
        acc.childMedia = [{ cgpUrl: value }];
      }
      if (key === "wvus_product_name") {
        acc.givenName = value;
      }
      return acc;
    },
    {}
  );
};
